import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=573217ca&scoped=true&"
import script from "./goals.vue?vue&type=script&lang=js&"
export * from "./goals.vue?vue&type=script&lang=js&"
import style0 from "./goals.vue?vue&type=style&index=0&id=573217ca&lang=scss&scoped=true&"
import style1 from "./goals.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573217ca",
  null
  
)

export default component.exports